export default __webpack_public_path__ + "static/media/endocrinology.cec37f91.png";